<div class="page-canvas">
  <main class="page-main">
    <div class="container layout layout--questions">
      <div class="layout__main in">
        <div class="question-stepper">
          <div class="question-stepper__img question-stepper__img--avatar">
            <img src="assets/{{session?.category_id}}/avatar/happy.png" class="icon">
          </div>
          @if (completion_status_id === 4) {
            <div class="question-stepper__content">
              <h3 class="font-normal">We have all we need for now. Please <strong>check</strong> the <strong>summary details</strong> below and submit
            when you’re ready.</h3>
          </div>
        }
        @if (completion_status_id !== 4) {
          <div class="question-stepper__content">
            <h3 class="font-normal">Please <strong>check</strong> the <strong>summary details</strong> below and submit
          when you’re ready.</h3>
        </div>
      }
    </div>
    @if (summary?.length) {
      <div class="question-stepper question-pull">
        <div class="question-stepper__content">
          <div class="card card--claim-summary">
            @if (completion_status_id === 3) {
              <div class="note note--error">
                <div class="note__content">
                  <h6 class="font-16">Required details were skipped</h6>
                  <p>Your claim cannot be registered until all required questions are answered. Please click Edit and complete the required fields.</p>
                </div>
              </div>
            }
            @if (completion_status_id === 2) {
              <div class="note">
                <div class="note__content">
                  <h6 class="font-16">Some optional details were skipped</h6>
                  <p>Your claim can still be registered, but providing more detail helps us process it faster.</p>
                </div>
              </div>
            }
            <div class="card-body card-body-edit">
              <div class="claim-summary-card">
                <div class="claim-summary-card__image">
                  <img src="assets/img/claims/event-crash-temp.svg" class="icon">
                  <img src="assets/{{session?.category_id}}/icn/claims-shield.svg" class="icon-secondary">
                </div>
                <div class="progress-tree__detail-description">
                  <h5 class="text-color-dark mb-4">{{claim_name}}</h5>
                  <p>
                    {{location_line_1}}
                    <span class="d-none d-md-block">{{location_line_2}}</span>
                  </p>
                  <p class="progress-tree__detail-date">{{date}}</p>
                </div>
                <div class="progress-tree__detail-actions">
                  <a href="javascript:;" (click)="editItem(event_details)" class="action-edit text-link">Edit</a>
                  <!-- Remove link never had a click handler (dead since introduction) — commented out per Asana SYSTEST-409, see PR for details -->
                  <!-- 
                  <span>|</span>
                  <a href="javascript:void(0)" class="action-remove text-link">Remove</a> 
                  -->
                  <div class="progress-tree__detail-actions-notification">
                    <span><span></span></span>
                  </div>
                </div>
              </div>
              @for (classItem of getClassHeaders(); track classItem) {
                <div class="progress-tree__title">
                  <p>{{classItem.class_name}}</p>
                  <!-- <a href="javascript:void(0)" class="action-add text-link">+ Add</a> -->
                </div>
                @for (item of getClassItems(classItem.class_id); track item) {
                  <div class="progress-tree__detail">
                    <div class="progress-tree__detail-name" title="{{getDescription(item.description, 1)}}">
                      {{getDescription(item.description, 1)}}
                    </div>
                    <div class="progress-tree__detail-description">
                      {{getDescription(item.description, 2)}}
                    </div>
                    <div class="progress-tree__detail-actions is-pending">
                      <a href="javascript:;" (click)="$event.preventDefault(); editItem(item)"
                      class="action-edit text-link">Edit</a>
                      <span>|</span>
                      <a href="javascript:;" (click)="$event.preventDefault(); removeItem(item)" class="action-remove text-link">Remove</a>
                    </div>
                  </div>
                }
              }
              <!--<div class="progress-tree__detail progress-tree__detail--benefit">
              <div class="progress-tree__detail-name" title="CAA 156893">
                <svg class="icon"><use xlink:href="#add-ons-loss-of-use"></use></svg>
                <span class="font-semibold">Loss of Use</span>
                <span class="tag-pill">Benefit</span>
              </div>
              <div class="progress-tree__detail-description">
                CAA 156893 - 2016 Suzuki Jimny 1.3
              </div>
              <div class="progress-tree__detail-actions is-pending">
                <a href="javascript:void(0)" class="action-edit text-link">Edit</a>
                <span>|</span>
                <a href="javascript:void(0)" class="action-remove text-link">Remove</a>
              </div>
            </div>-->
            @if (police_report) {
              <div class="progress-tree__detail mt-30">
                <div class="progress-tree__detail-name" title="">
                  {{getDescription(police_report.description, 1)}}
                </div>
                <div class="progress-tree__detail-description">
                  {{getDescription(police_report.description, 2)}}
                </div>
                <div class="progress-tree__detail-actions is-pending">
                  <a href="javascript:void(0)" (click)="$event.preventDefault(); editItem(police_report)" class="action-edit text-link">Edit</a>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
</div>
</main>
</div>

<app-disclaimer></app-disclaimer>

<footer class="question-tray">
  <div class="container">
    <div class="question-tray__controls">
      <div class="question-tray__btns question-tray__btns--claim-summary">
        <a href="javascript:;" (click)="addAnother()" class="button button--lg button--secondary">Add Another</a>
        <a href="javascript:;" (click)="handlePrimaryAction()" [ngClass]="{'is-disabled': submitting || !hasClaimItems}" class="button button--lg button--primary">{{ primaryButtonLabel }}</a>
      </div>
    </div>
  </div>
</footer>
<div class="modal fade modal--alert" id="register-modal" tabindex="-1" role="dialog"
  aria-labelledby="register-claim-modal" style="display: none;" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/{{session?.category_id}}/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3 class="mb-20">Thank you, your claim has been registered</h3>
          </div>
          <div class="mb-30">
            <h5 class="font-normal font-16">We will get back to you with the next steps - expect to hear from us within
            one to two business days. </h5>
          </div>


          @if (claim?.claim_completion_status_id === 2 || claim?.claim_completion_status_id === 3) {
            <div class="note mb-15 mb-0">
              <div class="note__icon">
                <svg class="icon">
                  <use xlink:href="#info"></use>
                </svg>
              </div>
              <div class="note__content">
                <h6>Some details were skipped</h6>
                <p>Skipped details prevent progress of your claim. You will be reminded to complete these.</p>
              </div>
            </div>
          }

          <div class="panel panel--reference no-shadow">
            <p class="font-semibold">
              Claim Reference No:
            </p>
            <div class="mb-15">
              <h5>
                {{claim?.claim_id}}
              </h5>
            </div>
            <!--<a href="javascript:void(0)" data-copy="copy-ref-target" class="input-group-icon input-group-icon&#45;&#45;copy">
            Share this Claim Summary
            <svg class="icon">
              <use xlink:href="#link"></use>
            </svg>
          </a>-->
        </div>

      </div>
    </div>

    <div class="modal-alert__button">
      <div class="container">
        <a routerLink="/everything.claims-landing" class="button button--lg button--primary button--block"
        data-dismiss="modal">View Claim Status</a>
      </div>
    </div>
  </div>
</div>
</div>


